import { useEffect, useRef } from 'react';

const useHotKey = (key, callback, options = {}) => {
    const { mod = true, shift = false, alt = false, enabled = true, preventDefault = true } = options;

    const callbackRef = useRef(callback);
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        if (!enabled || !key) return;

        const expected = key.length === 1 ? `Key${key.toUpperCase()}` : key;

        const handler = (event) => {
            if (mod !== (event.metaKey || event.ctrlKey)) return;
            if (shift !== event.shiftKey) return;
            if (alt !== event.altKey) return;
            if (event.code !== expected && !(key.length === 1 && event.key?.toLowerCase() === key.toLowerCase())) return;

            if (preventDefault) event.preventDefault();
            callbackRef.current?.(event);
        };

        document.addEventListener('keydown', handler, true);
        return () => document.removeEventListener('keydown', handler, true);
    }, [key, mod, shift, alt, enabled, preventDefault]);
};

export default useHotKey;
